export enum HeaderTheme {
	LIGHT = 'LIGHT',
	DARK = 'DARK',
	TRANSPARENT = 'TRANSPARENT',
	BLUE = 'BLUE',
}
